import React from 'react';
import M from '@block/utils';
import { render } from 'react-dom';
import { Router, Route, useRouterHistory, Redirect } from 'react-router';
import { createHashHistory, useBeforeUnload } from 'history/lib';
import { Modal, notification } from '@ss/mtd-react';
import Login from './nodes/login';
import Home from './nodes/home';
import List from './nodes/list';
import Sign from './nodes/sign';
import Success from './nodes/success';
import '@ss/mtd-react/lib/style/index.scss';
import './style/base.scss';
import './style/custom-theme.scss';
import './style/base-form.scss';
import '../icomoon/style.css';

let lastUnhandledRrejectionReason = null;
window.onunhandledrejection = ({ reason }) => {
  if (reason === lastUnhandledRrejectionReason) return;
  lastUnhandledRrejectionReason = reason;
  if (reason instanceof M.ApiError) {
    if (reason.errorCode === '401') {
      Modal.info({
        title: '登录信息失效啦，请重新登录',
        okBtnProps: { type: 'primary' },
        okText: '确定',
        onOk: async () => {
          // window.app.state.status = null;
          const { hash } = window.location;
          const arr = hash.split('/');
          const tenantUid = arr[2];
          window.location.hash = `#/candidate/${tenantUid}/login`;
        },
      });
    } else {
      notification.error({
        title: '错误',
        message: reason.message || '操作失败,稍后重试',
      });
    }
  } else {
    // console.error(reason);
  }
};
// 用户关闭浏览器页面或者刷新页面时,判断是否正在编辑页,若正在编辑页,弹窗提示用户
window.onbeforeunload = () => {
  // const { app } = window;
  // if (!isSave && app.state && app.state.status && (app.state.status === 1 || app.state.status === 8 || app.state.status === 9)) {
  //   return '当前数据还没有保存，关闭或刷新窗口会自动保存数据，是否继续?';
  // }
  return null;
};
window.onunload = function fn1() {
  // if (!isSave) {
  //   const { app } = window;
  //   app.state && app.state.status && (app.state.status = null);
  // }
};

function getUrl(url) {
  const { hash } = window.location;
  const arr = hash.split('/');
  const tenantUid = arr[2];
  // 请求路径上加tenantUid
  if (url?.startsWith('/api/candidate/') && !url.startsWith(`/api/candidate/${tenantUid}/`)) {
    const arr2 = url.split('/');
    arr2.splice(3, 0, tenantUid);
    url = arr2.join('/');
  }
  // 登录 登出 获取背调类型不需要添加标识
  if (
    url.indexOf('getBackgroundCheckType') > -1 ||
    url.indexOf('login') > -1 ||
    url.indexOf('logout') > -1 ||
    url.indexOf('completeSign') > -1
  ) {
    return url;
  }
  if (window.checkTypeValue === 'entry') {
    // 入职候选人 请求路径加前缀
    if (url.indexOf('getAuthorizationFile') > -1) {
      url = url.replace('/api/candidate/', '/api/candidate/background/');
    } else if (
      url.indexOf('getProtocolSignStatus') === -1 &&
      url.indexOf('createProtocol') === -1 &&
      url.indexOf('disableProtocol') === -1
    ) {
      // TODO: 协议相关地址外，加entry前缀
      url = url.replace('/api/candidate/', '/api/candidate/entry/');
    }
  }
  if (window.checkTypeValue === 'background') {
    // 入职背调
    url = url.replace('/api/candidate/', '/api/candidate/background/');
  }

  return url;
}

// 支持部署时的站点 URL 前缀
(() => {
  const _fetch = window.fetch;
  window.fetch = function fn2(url, ...args) {
    url = getUrl(url);
    return _fetch(url, ...args);
  };
})();

// (function (open) {
//   XMLHttpRequest.prototype.open = function (method, url, ...args) {
//     // const { hash } = window.location;
//     // const arr = hash.split('/');
//     const tenantUid = 1;
//     if (url && url.startsWith('/api/candidate/') && !url.startsWith(`/api/candidate/${tenantUid}/`)) {
//       const arr2 = url.split('/');
//       arr2.splice(3, 0, tenantUid);
//       url = arr2.join('/');
//     }
//     open.call(this, method, url, ...args);
//   };
// }(XMLHttpRequest.prototype.open));

// url发生变化时,判断是否正在编辑页,若正在编辑页,弹窗提示用户
// eslint-disable-next-line
const history = useRouterHistory(useBeforeUnload(createHashHistory))({
  queryKey: false,
  getUserConfirmation: (message, callback) => {
    Modal.warning({
      title: '保存警告?',
      message,
      onOk: () => {
        // const { app } = window;
        // if (app.state && app.state.status) {
        //   app.state.status = null;
        // }
        callback(true);
      },
      onCancel: () => {
        const { hash } = window.location;
        const arr = hash.split('/');
        window.location.hash = arr.slice(0, 3).join('/');
        callback(false);
      },
    });
  },
});
history.listenBefore((location, callback) => {
  // const { app } = window;
  // if (app.state && app.state.status && (app.state.status === 1 || app.state.status === 5)) {
  //   // callback("您正在编辑页面,确认要离开么?");
  //   if (new RegExp('^/candidate/[^/][0-9a-zA-Z]+/login$').test(location.pathname)) {
  //     const { pathname } = location;
  //     const arr = pathname.split('/');
  //     if (arr.length === 4 && arr[arr.length - 1] === 'login') {
  //       callback('您正在编辑页面,确认要离开么?');
  //     }
  //   } else {
  //     callback();
  //   }
  // } else {
  callback();
  // }
});

(async () => {
  history.listen(() => {
    // eslint-disable-next-line no-mixed-operators
    const pathname = (window.location.hash.slice(1) && window.location.hash.slice(1)) || '/';
    const misId = M.getCookie('_lxsdk_cuid', 'none'); // 灵犀PC端的用户设备标识，用来区分UV的
    const valLab = { custom: { pathname, misId } };
    window.LXAnalytics('pageView', valLab, null, 'c_ead_76nm3o19');
  });
})();

// window.app.owlOnErrorPush = (instance, defaultOnErrorPush) => {
//   if (browser.versions.mobile || browser.versions.android || browser.versions.ios || browser.versions.iPhone || browser.versions.iPad || browser.versions.weixin || browser.versions.qq) {
//     return false;
//   }
//   const { sec_category, content } = instance;

//   const categoryErrorList = ['SyntaxError', 'Can\'t find variable', 'Can\'t find variable', 'unhandledrejection', 'message', 'Const declarations are not supported in strict mode', 'jsError-NullPointerException'];
//   if (categoryErrorList.some((item) => sec_category.indexOf(item) > -1)) {
//     return false;
//   }

//   const errorList = ['Use of const in strict mode.', 'getFirstImage', 'getAbstract', 'undefined is not an object (evaluating \'document.getElementsByTagName("title")[0].innerHTML\')', 'SyntaxError', 'unhandledrejection', 'message', 'jsError-NullPointerException'];
//   if (errorList.some((item) => content.indexOf(item) > -1) || isEmpty(content)) {
//     return false;
//   }
//   return defaultOnErrorPush(instance);
// };

export const routesConfig = [
  {
    path: '/candidate/:tenantUid/login',
    pageName: '登录页',
    component: Login,
  },
  {
    path: '/candidate/:tenantUid/home',
    pageName: '主页-流程进度',
    component: Home,
  },
  {
    path: '/candidate/:tenantUid/sign',
    pageName: '电子签页',
    component: Sign,
  },
  {
    path: '/candidate/:tenantUid/success',
    pageName: '提交成功页',
    component: Success,
  },
  {
    path: '/candidate/:tenantUid/',
    pageName: '信息填写以及展示页面',
    component: List,
  },
];

render(
  <Router history={history}>
    <>
      {routesConfig.map(({ path, component }) => (
        <Route path={path} component={component} key={path} />
      ))}
    </>
    <Redirect from="*" to="/candidate/1/login" />
  </Router>,
  document.getElementById('app'),
);
